export enum LoginRegisterTabs{
    Login=0,
    Register=1
}


// WEBPACK FOOTER //
// ./src/app/security/security/login-and-register/loginRegisterTabs.enum.ts